import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo-container">
          <div className="logo">
            <div className="chicken-icon">
              <img 
                src="/images/chesters-logo.png" 
                alt="Chester's Chicken Logo" 
                className="logo-image"
                onError={(e) => {
                  // Fallback if image doesn't exist yet
                  e.target.style.display = 'none';
                  e.target.nextElementSibling.style.display = 'block';
                }}
              />
              <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg" style={{display: 'none'}} className="fallback-logo">
                {/* Chicken head (yellow/orange body) */}
                <ellipse cx="35" cy="38" rx="26" ry="28" fill="#fbbf24"/>
                {/* Blue bandana - wraps around head */}
                <path d="M 12 32 Q 12 28, 18 26 Q 25 24, 32 26 Q 38 28, 45 26 Q 52 24, 58 26 Q 58 30, 58 38 Q 58 46, 52 48 Q 45 46, 38 48 Q 32 46, 25 48 Q 18 46, 12 48 Q 12 42, 12 32 Z" fill="#2563eb"/>
                {/* Red comb on top - wavy/irregular */}
                <path d="M 28 8 L 30 4 L 32 7 L 33 2 L 35 6 L 37 3 L 39 7 L 41 4 L 42 8 L 42 12 L 28 12 Z" fill="#dc2626"/>
                {/* Yellow beak pointing left */}
                <path d="M 5 36 L 5 40 L 15 38 Z" fill="#fbbf24"/>
                <path d="M 5 36 L 5 40 L 12 38 L 5 36" stroke="#e5a317" strokeWidth="0.5" fill="none"/>
                {/* Eye - black circle with white highlight */}
                <circle cx="28" cy="33" r="3.5" fill="#1a1a1a"/>
                <circle cx="29" cy="32" r="1.2" fill="#ffffff"/>
              </svg>
            </div>
            <div className="logo-text">
              <h1 className="logo-name">Chester's</h1>
              <p className="logo-tagline">ON THE RUN</p>
            </div>
          </div>
        </Link>
        
        <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
          <span className={isMenuOpen ? 'hamburger open' : 'hamburger'}></span>
          <span className={isMenuOpen ? 'hamburger open' : 'hamburger'}></span>
          <span className={isMenuOpen ? 'hamburger open' : 'hamburger'}></span>
        </button>

        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <Link to="/" className={`nav-link ${isActive('/')}`} onClick={() => setIsMenuOpen(false)}>
            Home
          </Link>
          <Link to="/about" className={`nav-link ${isActive('/about')}`} onClick={() => setIsMenuOpen(false)}>
            About Us
          </Link>
          <Link to="/contact" className={`nav-link ${isActive('/contact')}`} onClick={() => setIsMenuOpen(false)}>
            Contact Us
          </Link>
          <Link to="/privacy" className={`nav-link ${isActive('/privacy')}`} onClick={() => setIsMenuOpen(false)}>
            Privacy Policy
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;

